module.exports = {
    Controller: require('./Controllers/CaseWorldController2'),
    BuilderApi: require('./Models/BuilderApi')
}


// WEBPACK FOOTER //
// ./node_modules/@thomann/caseconfigurator/lib/index.js